<template>
  <div class="content" ref="pie-chart"></div>
</template>

<script>
    import * as echarts from 'echarts';
    import {chartColors, xLabelColor} from "./constant";

    export default {
        name: "PieEChartComponent", // 饼图

        props: {
            /* 格式：[{value: 1048, name: '搜索引擎'},{value: 735, name: '直接访问'},{value: 580, name: '邮件营销'},] */
            data: {
                type: Array,
                required: true,
            },
            legend: {
                type: Object,
            },
        },

        mounted() {
            this.drawChart();
        },
        methods: {
            drawChart() {
                const myChart = echarts.init(this.$refs['pie-chart']);

                let legend = {
                    orient: 'horizontal',
                    top: '5%',
                    itemWidth: 10,
                    itemHeight: 10,
                    textStyle: {
                        color: xLabelColor[sessionStorage.getItem('theme')],
                    }
                };

                if (this.legend) {
                    legend = this.legend;
                }

                const option = {
                    color: chartColors,
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: legend,
                    grid: {
                        bottom: '3%',
                        left: 0,
                        right: 0,
                        containLabel: true
                    },
                    series: [
                        {
                            type: 'pie',
                            top: '10%',
                            radius: '70%',
                            label: {
                                color: xLabelColor[sessionStorage.getItem('theme')],
                            },
                            labelLine: {
                                lineStyle: {
                                    color: xLabelColor[sessionStorage.getItem('theme')],
                                }
                            },
                            data: this.data,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                myChart.setOption(option);
            }
        }
    }
</script>

<style scoped>
  .content {
    width: 100%;
    height: 100%;
  }
</style>
